import React from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles, useTheme } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Badge } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IEvent } from '../../models/IEvent';

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    },
    appBarSpacer: theme.mixins.toolbar
}),
);

// const SmallAvatar = makeStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             width: 30,
//             height: 30,
//             border: `2px solid ${theme.palette.background.paper}`,
//         },
//     }),
// )(Avatar);

interface IEventCardProps {
    eventId: string;
    description?: string | null;
    circuitName: string;
    eventName: string;
    eventDate: Date;
    circuitLogo: string;
    organizer: string;
    organizerLogo: string;
}
function EventCard(props: IEventCardProps) {
    const classes = useStyles();
    const theme = useTheme();
    const { i18n } = useTranslation('common');
    const parsedEventDate = new Date(props.eventDate);
    const localizedDate = Number.isNaN(parsedEventDate.getTime())
        ? ''
        : parsedEventDate.toLocaleDateString(i18n.language);
    const eventSummary = [localizedDate, props.circuitName].filter(Boolean).join(' ');
    const hasDescription = typeof props.description === 'string' && props.description.trim().length > 0;
    const organizerDescription = hasDescription
        ? `${props.organizer}: ${props.description}`
        : props.organizer;

    return (
        <Link to={`/event/${props.eventId}`} >
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Badge overlap="circular" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} badgeContent={<Avatar alt={props.organizer} src={props.organizerLogo} sx={{
                        width: 30,
                        height: 30,
                        border: `2px solid ${theme.palette.background.paper}`
                    }} />} >
                        <Avatar alt={props.eventName} src={props.circuitLogo} />
                    </Badge>
                </ListItemAvatar>
                <ListItemText
                    primary={props.eventName}
                    secondaryTypographyProps={{ component: 'div' }}
                    secondary={
                        <React.Fragment>
                            <Typography
                                component="div"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                            >
                                {eventSummary}
                            </Typography>
                            <Typography
                                component="div"
                                variant="body2"
                                color="textSecondary"
                            >
                                {organizerDescription}
                            </Typography>

                        </React.Fragment>
                    }
                />
            </ListItem>
        </Link>
    );
}

interface IEventListProps {
    events: IEvent[];
}

function EventList(props: IEventListProps) {
    const classes = useStyles();
    const { events } = props;

    return (
        <React.Fragment>
            <List className={classes.root} >
                {
                    events.map(function (eventData) {
                        return <EventCard
                            eventId={eventData.raceId}
                            key={eventData.raceId}
                            eventName={eventData.name}
                            circuitLogo={eventData.circuitLogo}
                            circuitName={eventData.circuitName}
                            description={eventData.description}
                            eventDate={eventData.eventDate}
                            organizer={eventData.organizerName}
                            organizerLogo={eventData.organizerLogo} />
                    })
                }
            </List>
        </React.Fragment>
    );
}

export default EventList;